import dayjs, { Dayjs } from 'dayjs';

export const formatDate = (date: Dayjs | null) => {
  if (date === null) return '';
  return dayjs(date).format('YYYY.MM.DD');
};

function r() {
  return Math.floor(Math.random() * 256);
}

export const generateColor = (dataLength: number) => {
  const arr: Array<string> = [];
  for (let i = 0; i < dataLength; i++) {
    arr.push('rgb(' + r() + ',' + r() + ',' + r() + ')');
  }
  return arr;
};